import { Component, Inject } from '@angular/core';
import { AbstractControlOptions, UntypedFormBuilder, UntypedFormGroup, ValidationErrors, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ModalHeaderComponent } from '../../../shared/modal/modal-header/modal-header.component';
import { MatLabel, MatFormField, MatSuffix } from '@angular/material/form-field';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { MatInput } from '@angular/material/input';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';
import { ValidateButtonComponent } from '../../../shared/buttons/validate-button.component';
import { TranslocoPipe } from '@jsverse/transloco';

export interface BuildingReportUpload {
  report: File;
  controlDate?: Date;
}

@Component({
  selector: 'sibat-upload-report-dialog',
  templateUrl: './upload-report-dialog.component.html',
  styleUrls: ['./upload-report-dialog.component.scss'],
  imports: [
    ModalHeaderComponent,
    ReactiveFormsModule,
    MatLabel,
    MatRadioGroup,
    MatRadioButton,
    MatFormField,
    MatInput,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatSuffix,
    MatDatepicker,
    ValidateButtonComponent,
    TranslocoPipe,
  ],
})
export class UploadReportDialogComponent {
  readonly oldReport = this.formBuilder.control('');
  readonly date = this.formBuilder.control(null);
  readonly uploadForm = this.formBuilder.group(
    {
      isOldReport: this.oldReport,
      controlDate: this.date,
    },
    {
      validators: this.oldControlValidator,
    } as AbstractControlOptions
  );

  constructor(
    private formBuilder: UntypedFormBuilder,
    public dialogRef: MatDialogRef<UploadReportDialogComponent, BuildingReportUpload>,
    @Inject(MAT_DIALOG_DATA) public data: { file: File }
  ) {}

  oldControlValidator(group: UntypedFormGroup): ValidationErrors | null {
    const oldReport = group.controls.isOldReport.value;
    const date = group.controls.controlDate.value;
    if (oldReport === 'false' || (oldReport === 'true' && date)) {
      return null;
    }
    return { error: 'invalid form' };
  }

  onValidateForm() {
    const result: BuildingReportUpload = {
      report: this.data.file,
      controlDate: this.oldReport.value === 'true' ? this.date.value : undefined,
    };
    this.dialogRef.close(result);
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
